<template>
    <v-card flat>
        <v-card-title>
            <a @click="backClick()" class="back-button"><v-icon small color="primary">chevron_left</v-icon>Back</a>
            <v-spacer></v-spacer>
            <a v-if="audio" class="audio-button" @click="toggleAudio()">
                <v-icon v-if="audioEnabled" small color="primary">volume_up</v-icon>
                <v-icon v-else small color="primary">volume_off</v-icon>
            </a>
            <v-spacer></v-spacer>
            <a @click="requestHelp()" class="help-button"><v-icon small color="primary">help</v-icon></a>
        </v-card-title>
        <slot name="image"></slot>
        <v-card-text>
            <slot></slot>
        </v-card-text>
        <slot name="audio">
            <div v-if="audio">
                <audio :autoplay="audioEnabled" :src="require(`@/assets/audio/${this.section}-${this.page}.mp4`)" ref="audio"></audio>
            </div>
        </slot>
        <v-card-actions>
            <slot name="actions">
                <v-spacer></v-spacer>
                <v-btn round large color="primary" @click="nextClick()" :disabled="nextDisabled()">{{ nextLabel }}</v-btn>
                <v-spacer></v-spacer>
            </slot>
        </v-card-actions>
        <v-dialog v-model="helpDialog" persistent>
            <v-card class="client-dialog">
                <v-card-text>
                    <p class="headline text-xs-center">Need some help?</p>
                    <p>
                        If you are stuck on an activity or if the app is not working properly, submit a message and a site coordinator will contact you in the
                        next 24-48 hours.
                    </p>
                    <v-textarea hide-details outline label="What issues are you having?" :rows="4" auto-grow v-model.trim="appIssues" clearable></v-textarea>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn round outline color="primary" @click="cancelHelp">Cancel</v-btn>
                    <v-btn round outline color="primary" @click="submitHelp" :disabled="!appIssues">Submit</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import goTo from 'vuetify/lib/components/Vuetify/goTo';
import router from '@/router';

export default {
    data: function() {
        return {
            helpDialog: false,
            appIssues: ''
        };
    },
    props: {
        section: {
            type: Number,
            required: true
        },
        page: {
            type: Number,
            required: true
        },
        backOverrideFunction: {
            type: Function,
            default: null
        },
        next: {
            type: String,
            default: null
        },
        nextLabel: {
            type: String,
            default: 'Next'
        },
        nextFunction: {
            type: Function,
            default: null
        },
        nextDisabled: {
            type: Function,
            default: () => false
        },
        audio: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        backClick() {
            if (this.backOverrideFunction) {
                this.backOverrideFunction();
            } else {
                router.back();
            }
        },
        nextClick() {
            if (this.nextFunction) {
                this.nextFunction();
            }
            router.push(this.next || `/page/${this.section}/${this.page + 1}`);
        },
        toggleAudio() {
            if (this.audioEnabled) {
                this.$store.set(`audioEnabled`, false);
                this.$refs.audio.pause();
            } else {
                this.$store.set(`audioEnabled`, true);
                this.$refs.audio.play();
            }
        },
        requestHelp() {
            this.helpDialog = true;
        },
        cancelHelp() {
            this.helpDialog = false;
            this.appIssues = '';
        },
        submitHelp() {
            this.helpDialog = false;
            this.$api.post('/help', { path: this.$route.path, section: this.section, page: this.page, text: this.appIssues }).then(() => {});
            this.appIssues = '';
        }
    },
    computed: {
        audioEnabled() {
            return this.$store.get(`audioEnabled`);
        }
    },
    mounted() {
        this.$nextTick(() => {
            goTo(0);
        });
    }
};
</script>

<style scoped>
.back-button {
    z-index: 100;
}
.audio-button {
    z-index: 100;
}
.help-button {
    z-index: 100;
}
</style>
